import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import { FONT_FAMILIES, FONT_SIZES, COLOR, SPACE } from 'config';
import { Flex, Box } from 'grid-styled';
import { rem } from 'polished';
import ReactMd from 'react-md-file';
import Sticky from 'react-sticky-el';

import styled from 'styled-components';
import Header from 'components/Header';
import Footer from 'components/Footer';
import TopBanner from 'components/TopBanner';
import SignUpSection from 'components/SignUpSectionSecondary';
import Container from 'components/Container';
import CxSideMenu from '../CxSideMenu';
import banner from '../../images/CX.svg';
import docs from '../../content/CX-Chains-Overview.md';

const Banner = styled(TopBanner)`
  background-color: #101F34;
`;

const Render = styled.div`
  margin-bottom: ${rem(SPACE[5])};
  font-family: ${FONT_FAMILIES.sans};
  color: ${COLOR.textDark};
  font-size: ${rem(FONT_SIZES[2])};
  line-height: ${rem(25)};
  word-break: break-word;

  pre {
    padding: 40px;
    background-color: #F8F8F8;
    word-break: break-all !important;
    white-space: -moz-pre-wrap;
    white-space: pre-wrap;

    code {
      word-break: break-all !important;
      white-space: -moz-pre-wrap;
      white-space: pre-wrap;
    }
  }

  a {
    text-decoration: none !important;
    color: ${COLOR.base};
  }

  img {
    width: 100% !important;
    height: auto;
  }
`;

const CXChains = ({ intl }) => (
  <div>
    <Helmet>
      <title>{intl.formatMessage({ id: 'cx.title' })}</title>
      <meta
        name="description"
        content={intl.formatMessage({ id: 'cx.description' })}
      />
    </Helmet>
    <Header />
    <Banner src={banner} />
    <Container>
      <Render>
        <Flex wrap>
          <Box width={[1, 1, 1 / 4]} px={2}>
            <Sticky>
              <CxSideMenu />
            </Sticky>
          </Box>
          <Box width={[1, 1, 3 / 4]} px={2} pb={10}>
            <div>
              <ReactMd fileName={docs} />
            </div>
          </Box>
        </Flex>
      </Render>
    </Container>
    <SignUpSection />
    <Footer />
  </div>
);

CXChains.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(CXChains);



// WEBPACK FOOTER //
// ./src/components/CXs/components/CxChains/CXChains.js